<div class="cart">
  <app-clickable-row
    icon="icon-cart"
    [(isOpen)]="isCartExpanded"
    [label]="'Order Summary (' + (cartItems().length || 0) + ' Items)'"
  />

  @if (isCartExpanded()) {
    <div @slideInOut class="cart__list">
      @for (product of cartItems(); track $index) {
        @let isUpdateDisabled =
          isLocked() ||
          isDeleteLoading() ||
          isUpdateLoading() ||
          isSyncLoading() ||
          isAddItemLoading() ||
          !product?.quantity_limits?.editable;

        <app-checkout-details-cart-item
          [name]="product.name"
          [price]="product.prices.price"
          [image]="(product | productImage) || ''"
          [quantity]="product.quantity"
          [addOns]="product.item_data"
          [minQuantity]="product?.quantity_limits?.minimum || 1"
          [maxQuantity]="product?.quantity_limits?.maximum || 100"
          [cartMinorUnit]="cartTotals().currency_minor_unit || 2"
          [isDisabled]="isUpdateDisabled"
          (remove)="removeProduct(product.key)"
          (update)="updateProductQuantity(product.key, $event)"
        />
      } @empty {
        <span class="cart__list-empty">Your cart is empty</span>
      }
    </div>
  }
</div>
